import { render, staticRenderFns } from "./DetailsBottomItem.vue?vue&type=template&id=a2176750&scoped=true&"
import script from "./DetailsBottomItem.vue?vue&type=script&lang=js&"
export * from "./DetailsBottomItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBottomItem.vue?vue&type=style&index=0&id=a2176750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2176750",
  null
  
)

export default component.exports